module.exports = __webpack_public_path__ + "img/@go_to_work_img_00_m_off.da5bc821.jpg";